import Vue from 'vue'
import AnalyticsPlugin from './plugin'

Vue.use(AnalyticsPlugin)
